import type { ApolloError } from '@apollo/client';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { activeRecord } from '../lib/graphql/common/queries';
import { genericScalars } from '../lib/graphql/helpers';

const operationName = 'querySocMembers';

/**
 * Provides GraphQL query to get all ids of active users in the NSW RFS State Operation Centre.
 */
const useQuerySocMembers = (
  onCompleted: (ids: readonly string[]) => void,
  onError?: (e: ApolloError) => void
) =>
  useTypedQuery(
    {
      team: [
        { where: { name: { _eq: 'NSW RFS State Operation Centre' } } },
        {
          team_role_assignments: [
            { where: activeRecord },
            {
              user_role_assignments: [
                { where: activeRecord },
                { user_id: true },
              ],
            },
          ],
        },
      ],
    },
    {
      apolloOptions: {
        onError,
        onCompleted: (data) =>
          onCompleted(
            data.team
              .map(({ team_role_assignments }) =>
                team_role_assignments.map(({ user_role_assignments }) =>
                  user_role_assignments.map(({ user_id }) => user_id)
                )
              )
              .flat(2)
          ),
      },
      operationOptions: { operationName },
      scalars: genericScalars,
    }
  );

export default useQuerySocMembers;
